module.exports = __webpack_public_path__ + "img/icon-close-white.54f5cfa4.svg";